import api from 'ApiConfig';

const assignmentService = {
  //   createCourse: async (data) => {
  //     return api.post('/admin/create-course', data);
  //   },
  getDailyAssignment: async () => {
    return api.post('/student/assignment-daily');
  },
  getWeeklyAssignment: async () => {
    return api.post('/student/assignment-weekly');
  },
  getMonthlyAssignment: async () => {
    return api.post('/student/assignment-monthly');
  },
  getEndAssignment: async () => {
    return api.post('/student/assignment-end-assignment');
  },
  submitAssignmentAnswers: async (payload) => {
    return api.post('/student/student-submit-assignment', payload);
  },
  viewAttendedAssignmnet: async () => {
    return api.post('/student/view-attended-assignment');
  },
  uploadAssignment: async (file) => {
    console.log(file, 'assignmnet service ');
    return api.post('/student/upload-assignments', file);
  },
  getuploadedAssignments: async (assignmentId) => {
    return api.post('/student/get-uploaded-assignments', { assignmentId });
  },
  deleteuploadedAssignment: async (filename) => {
    return api.post('/student/delete-uploaded-assignments', filename);
  },
  getAllPracticalAssignments: async () => {
    return api.post('/student/get-students-assigned-practicle');
  },
};
export default assignmentService;
